module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/page-loaders/page-loaders.component.scss
// module id = ./src/app/page-loaders/page-loaders.component.scss
// module chunks = main